import { useMediaQuery } from '@mui/material';
import { AppInsightsContext } from '@shared/components/AppTelemetry/AppTelemetryProvider';
import NotFoundIcon from '@shared/components/Icons/NotFound';
import LayoutContainer from '@shared/components/Layout/LayoutContainer';
import { useContext, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import styles from './index.module.scss';

export default function NotFoundPage() {
    const { logPageView } = useContext(AppInsightsContext);
    const isMobile = useMediaQuery('(max-width: 600px)');
    const headingSize = isMobile ? 'small' : 'medium';
    const lineHeight = isMobile ? 'xsmall' : 'base';

    useEffect(() => {
        logPageView('Not Found');
    }, [logPageView]);

    return (
        <>
            <Helmet>
                <title>You found a blank page</title>
            </Helmet>
            <LayoutContainer includeFooter hideSubHeader>
                <div className={styles['not-found']}>
                    <hzn-stack space="base" align-x="center" align-y="center">
                        <NotFoundIcon />
                        <hzn-heading
                            as="h1"
                            align="center"
                            size={headingSize}
                            line-height={lineHeight}>
                            You found a blank page
                        </hzn-heading>
                        <div className={styles['not-found-text']}>
                            <hzn-text
                                variant="text"
                                size="base"
                                tone="body"
                                weight="base"
                                align="center"
                                as="p"
                                line-height="base">
                                This page may have moved or no longer exists. Refresh or try our{' '}
                                <hzn-text-link href="/memberdashboard">
                                    Member Dashboard
                                </hzn-text-link>{' '}
                                to find what you&apos;re looking for.
                            </hzn-text>
                        </div>
                    </hzn-stack>
                </div>
            </LayoutContainer>
        </>
    );
}
